import { Container } from 'react-bootstrap';
import './FAQBanner.css';

export const FAQBanner = () => {
  return (
    <div className="faq-banner">
      <Container className="bg-header bg-transparent">
        <div className="faq-banner-content">
          <h1 className="faq-banner-title">Frequently Asked Questions</h1>
        </div>
      </Container>
    </div>
  );
};
